<p-card *ngIf="content" class="w-full" styleClass="h-full">
    <ng-template pTemplate="content">
        <div class="flex flex-column align-items-start justify-content-between h-full gap-3">
            <div *ngIf="content.tagValue">
                <p-tag [value]="content.tagValue"
                    styleClass="text-rose-900 bg-rose-100 font-normal"><i class="pi pi-exclamation-triangle text-rose-900 text-xs"></i>
                </p-tag>
                <p *ngIf="content.title" class="text-md text-slate-800" [innerHTML]="content.title"></p>
            </div>
            <div *ngIf="content.button" class="p-0 col-12 md:col-7">
                <p-button [rounded]="true" [label]="content.button.name" severity="warn" class="w-full"
                    styleClass="w-full md:max-w-19rem shadow-button" [attr.data-auto-id]="buttonAutoId"
                    (click)="navigate()">
                </p-button>
            </div>
        </div>
    </ng-template>
</p-card>